import React, { FC, useMemo } from 'react';

import AampeItalicText from '../../../../../components/shared/AampeText/AampeItalicText';
import styled from 'styled-components';

import aampeTheme from '../../../../../constants/aampeTheme';

import { getEmailFieldData } from '../../../../../helpers/formulaHelpers';

import { EmailFieldDataModel } from '../../../../../models/formula.model';

import ImageAlternateToolTip from './ImageAlternateToolTip';

interface ImageInputLabelProps {
    isRequired?: boolean;
    isEmail: boolean;
    label?: string;
    inputType: string;
}

const ImageInputLabel: FC<ImageInputLabelProps> = ({
    isRequired,
    isEmail,
    label,
    inputType,
}) => {
    const emailFieldData = useMemo<EmailFieldDataModel>(
        () => getEmailFieldData(inputType),
        [inputType],
    );
    return (
        <Container>
            <Label>
                <LabelText>
                    <span>
                        {isEmail
                            ? emailFieldData.label
                            : label
                            ? label
                            : 'Image'}
                    </span>
                    <ImageAlternateToolTip />
                    {isRequired && <AampeItalicText text={'(Required)'} />}
                </LabelText>
            </Label>
        </Container>
    );
};

const Container = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: aampeTheme.size.font.default,
    fontWeight: aampeTheme.weights.extraHeavy,
});

const Label = styled.div({
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    columnGap: aampeTheme.spacing4(2),
});

const LabelText = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: aampeTheme.spacing4(2),
    fontSize: aampeTheme.size.font.default,
    fontWeight: 500,
    lineHeight: '20px',
    color: aampeTheme.colors.gray800,
});

export default ImageInputLabel;
